import React from 'react';
import Globe from '../../../assets/svgComponents/Globe';
import AutocompleteDropdownComponent from '../../common/genericComponents/autocompleteDropdownComponent';
import scheduleUtils from '../scheduleUtils';
import './timeZonePicker.css';

const TimeZonePicker = (props) => {
  const {isDisabled, selectedTimezone, selectTimeZone, globeColor} = props;
  const timezoneList = scheduleUtils.getTimeZones();
  const getLabel = () =>
    timezoneList.find((element) => element.key === selectedTimezone)?.value ||
    '';

  return (
    <div className="et-tzp-sr-s1-timezone">
      <Globe
        fillColor={`${globeColor ?? 'var(--et-mentor-cta-btn-primary-background-color-fc)'}`}
      />
      <div
        className={
          'et-tzp-sr-bor-tz-select' +
          (isDisabled ? ' et-tzp-sr-bor-tz-select-disabled' : '')
        }>
        <AutocompleteDropdownComponent
          value={getLabel()}
          options={timezoneList}
          selectedOption={(e) => selectTimeZone(e)}
          title="Select Timezone"
          labelKey="value"
          valueKey="key"
          enableAutoComplete={true}
          isDisabled={isDisabled}
        />
      </div>
    </div>
  );
};

export default TimeZonePicker;
